
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  BusinessReferralWebPreferencesResource,
  ReferralResource,
  ReferrerAlertsResource,
  UpdateReferralRewardPercentageRequest,
  UpdateReferrerRequest,
} from '../models';
import {
    BusinessReferralWebPreferencesResourceFromJSON,
    BusinessReferralWebPreferencesResourceToJSON,
    ReferralResourceFromJSON,
    ReferralResourceToJSON,
    ReferrerAlertsResourceFromJSON,
    ReferrerAlertsResourceToJSON,
    UpdateReferralRewardPercentageRequestFromJSON,
    UpdateReferralRewardPercentageRequestToJSON,
    UpdateReferrerRequestFromJSON,
    UpdateReferrerRequestToJSON,
} from '../models';

export interface FindReferralsByReferrerRequest {
    referrerIdentityId: string;
}

export interface GenerateInvoiceRequest {
    referredProjectDeliverableId: string;
}

export interface RetriggerReferralRewardPaymentRequest {
    referredProjectDeliverableId: string;
}

export interface UpdateReferralRewardPercentageOperationRequest {
    referralId: string;
    updateReferralRewardPercentageRequest: UpdateReferralRewardPercentageRequest;
}

export interface UpdateReferrerOperationRequest {
    referralId: string;
    updateReferrerRequest: UpdateReferrerRequest;
}

/**
 * 
 */
export class BusinessReferralApi extends runtime.BaseAPI {

    /**
          */
    async acknowledgeOnboardingRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/business-referral/api/acknowledge-onboarding`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async acknowledgeOnboarding(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeOnboardingRaw(initOverrides);
    }

    /**
     * Find all referrals of a referrer
          */
    async findReferralsByReferrerRaw(requestParameters: FindReferralsByReferrerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ReferralResource>>> {
        if (requestParameters['referrerIdentityId'] == null) {
            throw new runtime.RequiredError(
                'referrerIdentityId',
                'Required parameter "referrerIdentityId" was null or undefined when calling findReferralsByReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ReferralResource>>({
            path: `/business-referral/api/referrer/{referrerIdentityId}/referrals`.replace(`{${"referrerIdentityId"}}`, encodeURIComponent(String(requestParameters['referrerIdentityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ReferralResourceFromJSON);
        return response;
    }

    /**
     * Find all referrals of a referrer
          */
    async findReferralsByReferrer(requestParameters: FindReferralsByReferrerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ReferralResource>> {
        const response = await this.findReferralsByReferrerRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async generateInvoiceRaw(requestParameters: GenerateInvoiceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['referredProjectDeliverableId'] == null) {
            throw new runtime.RequiredError(
                'referredProjectDeliverableId',
                'Required parameter "referredProjectDeliverableId" was null or undefined when calling generateInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/business-referral/api/referred-project-deliverables/{referredProjectDeliverableId}/generate-invoice`.replace(`{${"referredProjectDeliverableId"}}`, encodeURIComponent(String(requestParameters['referredProjectDeliverableId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async generateInvoice(requestParameters: GenerateInvoiceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.generateInvoiceRaw(requestParameters, initOverrides);
    }

    /**
          */
    async getBusinessReferralWebPreferencesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<BusinessReferralWebPreferencesResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<BusinessReferralWebPreferencesResource>({
            path: `/business-referral/api/web-preferences`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=BusinessReferralWebPreferencesResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getBusinessReferralWebPreferences(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<BusinessReferralWebPreferencesResource> {
        const response = await this.getBusinessReferralWebPreferencesRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getReferrerAlertsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ReferrerAlertsResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ReferrerAlertsResource>({
            path: `/business-referral/api/referrer/alerts`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ReferrerAlertsResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getReferrerAlerts(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ReferrerAlertsResource> {
        const response = await this.getReferrerAlertsRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async retriggerReferralRewardPaymentRaw(requestParameters: RetriggerReferralRewardPaymentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['referredProjectDeliverableId'] == null) {
            throw new runtime.RequiredError(
                'referredProjectDeliverableId',
                'Required parameter "referredProjectDeliverableId" was null or undefined when calling retriggerReferralRewardPayment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/business-referral/api/referred-project-deliverables/{referredProjectDeliverableId}/retrigger-payment`.replace(`{${"referredProjectDeliverableId"}}`, encodeURIComponent(String(requestParameters['referredProjectDeliverableId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async retriggerReferralRewardPayment(requestParameters: RetriggerReferralRewardPaymentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.retriggerReferralRewardPaymentRaw(requestParameters, initOverrides);
    }

    /**
     * Admin can update the BRP reward for a referral
          */
    async updateReferralRewardPercentageRaw(requestParameters: UpdateReferralRewardPercentageOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling updateReferralRewardPercentage().'
            );
        }

        if (requestParameters['updateReferralRewardPercentageRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferralRewardPercentageRequest',
                'Required parameter "updateReferralRewardPercentageRequest" was null or undefined when calling updateReferralRewardPercentage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/{referralId}/reward`.replace(`{${"referralId"}}`, encodeURIComponent(String(requestParameters['referralId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralRewardPercentageRequestToJSON(requestParameters['updateReferralRewardPercentageRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Admin can update the BRP reward for a referral
          */
    async updateReferralRewardPercentage(requestParameters: UpdateReferralRewardPercentageOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReferralRewardPercentageRaw(requestParameters, initOverrides);
    }

    /**
     * Admin can update the BRP referrer for a referral
          */
    async updateReferrerRaw(requestParameters: UpdateReferrerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling updateReferrer().'
            );
        }

        if (requestParameters['updateReferrerRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferrerRequest',
                'Required parameter "updateReferrerRequest" was null or undefined when calling updateReferrer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/{referralId}/referrer`.replace(`{${"referralId"}}`, encodeURIComponent(String(requestParameters['referralId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferrerRequestToJSON(requestParameters['updateReferrerRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Admin can update the BRP referrer for a referral
          */
    async updateReferrer(requestParameters: UpdateReferrerOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReferrerRaw(requestParameters, initOverrides);
    }

}
